// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".empty-list[data-v-e1141ee2] {\n  min-height: 100px;\n  margin-bottom: 50px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 30px;\n  color: #cccccc;\n  font-weight: bold;\n}", ""]);
// Exports
module.exports = exports;
